import { AiOutlineShoppingCart } from 'react-icons/ai';
const CommerceIcon = () => <AiOutlineShoppingCart size={20} />;

export default CommerceIcon;
